import { Component, Input, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-confirmation-remove-modal',
  imports: [],
  templateUrl: './confirmation-remove-modal.component.html',
})
export class ConfirmationRemoveModalComponent {
  readonly ngbActiveModal = inject(NgbActiveModal);

  @Input() action: string = 'remove';
  @Input() confirmationBtnText: string = 'Remove';
  @Input() subject!: string;
  @Input() removeMessage!: string;

  public onCancel(): void {
    this.ngbActiveModal.dismiss();
  }

  public onAccept(): void {
    this.ngbActiveModal.close(true);
    // Add functionality for a toast message (success or failure) on submit
  }
}
